module.exports = __webpack_public_path__ + "static/assets/44541df59fd6a8070d12e95c6c4b63bd.png";